import {
  Appointment,
  refusalCategories,
  AppointmentStatus,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { formatDate, getUserShortName } from "@/src/utils/utils";

export function getPrintableStatusTitle(appointment: Appointment) {
  let typeName = appointment.type?.name || "";
  if (appointment.status == "validated")
    return `Rendez-vous ${typeName} validé \n en attente de programmation.`;
  if (appointment.status == "scheduled")
    return `Rendez-vous ${typeName} programmé`;
  if (appointment.status == "refused") {
    let refusalInfo = appointment.refusalCategory
      ? refusalCategories[appointment.refusalCategory]
      : null;
    return `Réponse défavorable pour ${appointment.type?.name} \n ${
      refusalInfo?.name || ""
    }`;
  }
  return "Demande de rendez-vous";
}

export async function getPrintableStatusContent(appointment: Appointment) {
  let statusChanges = await apiFetch("general", "loadStatusChanges", {
    itemId: appointment.id,
  });

  function statusChangeUserName(appointmentStatus: AppointmentStatus) {
    let statusChange = statusChanges?.find(
      (sc) => sc.newStatus == appointmentStatus
    );
    if (!statusChange) return "";
    let userName = getUserShortName(statusChange.creator) || "";
    if (!userName) return "";
    return `par ${userName}`;
  }

  if (appointment.status == "validated")
    return `Votre rendez-vous a été validé ${statusChangeUserName(
      "validated"
    )} et est en attente de programmation. . \n\n\n ${getPreprationsHtml(
      appointment
    )}`;

  if (appointment.status == "refused")
    return (
      appointment.refusalNotes ||
      "Votre demande de rendez-vous n'a pas été acceptée."
    );
  if (appointment.status == "scheduled")
    return `Rendez-vous validé ${statusChangeUserName(
      "validated"
    )} et programmé ${statusChangeUserName("scheduled")} pour le ${formatDate(
      appointment.start,
      "LL à HH:mm"
    )} : ${getUserShortName(appointment.doctor)}. \n\n\n ${getPreprationsHtml(
      appointment
    )}`;

  return "";
}

export function getPreprationsHtml(appointment: Appointment) {
  console.log("appointment", appointment);
  if (!appointment?.preparations) return "";
  return appointment.preparations
    .filter((preparation) => preparation?.description)
    .map((preparation) => {
      return `- ${preparation?.description || ""}`;
    })
    ?.join("\n\n");
}
